<template>
  <div class="student_box">
    <div class="title">大学生信息填报</div>
    <Form :label-width="80" :model="params" class="filter_form">
      <Row>
        <Col :md="6" :sm="24">
          <FormItem label="关键字">
            <Input v-model="params.keyword" placeholder="姓名、联系方式、证件号"></Input>
          </FormItem>
        </Col>
        <Col :md="6" :sm="24">
          <FormItem label="审核状态">
            <Select v-model="params.reviewStatus" placeholder="请输入">
              <Option :value="1">待审核</Option>
              <Option :value="2">审核通过</Option>
              <Option :value="3">审核失败</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :md="6" :sm="24">
          <FormItem label="在职状态">
            <j-dict-select-tag
              v-model="params.jobStatus"
              defaultName="全部"
              :hasAll="false"
              :triggerChange="true"
              @on-change="change('jobStatus', $event)"
              placeholder="请选择"
              dictCode="job_status"
            />
          </FormItem>
        </Col>
        <Col :md="6" :sm="24">
          <FormItem label="毕业院校">
            <Input v-model="params.schoolName" placeholder="请输入毕业院校"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div class="btns_class">
      <div class="left_btns">
        <Button @click="downLoadTemplate" type="primary">模板下载</Button>
        <Upload
          :show-upload-list="false"
          :multiple="false"
          :action="uploadAction"
          :headers="headers"
          :on-success="handleSuccess"
          :data="{ biz: 'temp' }"
          :max-size="maxSize"
          :on-exceeded-size="exceededSize"
        >
          <Button type="primary">导入</Button>
        </Upload>
        <Button @click="goAdd" type="primary">新增</Button>
      </div>
      <div>
        <Button @click="handleReset">重置</Button>
        <Button @click="handleSearch" type="primary">查询</Button>
      </div>
    </div>
    <Table class="student_table" :columns="column" :data="collegeInfoList">
      <template slot-scope="{ index }" slot="order">
        <span>{{ (page.pageNo - 1) * page.pageSize + index + 1 }}</span>
      </template>
      <template slot-scope="{ row }" slot="name">
        <span class="name" @click="goDetail(row)">{{ row.name }}</span>
      </template>
      <template slot-scope="{ row }" slot="reviewStatus">
        <span>{{ statusList[row.reviewStatus - 1] }}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <span class="action_btn" v-if="row.reviewStatus != 3" @click="goEdit(row)">编辑</span>
        <Divider v-if="row.reviewStatus != 3" type="vertical" />
        <span class="action_btn" @click="goDel(row.id)">删除</span>
      </template>
    </Table>
    <div class="page">
      <Page :total="page.total" show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageChange"></Page>
    </div>
    <studentModal @handleOk="initData" ref="studentModal"></studentModal>
    <Modal v-model="showMessage" title="温馨提示" @on-cancel="showMessage = false" @on-ok="showMessage = false">
      <div class="tips_content">{{ uploadMessage }}</div>
    </Modal>
  </div>
</template>

<script>
import JDictSelectTag from '@/components/JDictSelectTag'
import ApplyApi from '../../api/apply'
import studentModal from './modules/studentModal'

export default {
  name: 'studentInfo',
  components: { JDictSelectTag, studentModal },
  data() {
    return {
      params: {},
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      showMessage: false,
      uploadMessage: '',
      maxSize: 1024 * 50,
      uploadAction: ``,
      headers: '',
      column: [
        {
          title: '序号',
          width: 60,
          align: 'center',
          slot: 'order'
        },
        {
          title: '姓名',
          key: 'name',
          width: 100,
          slot: 'name',
          align: 'center'
        },
        {
          title: '证件号码',
          key: 'idNum',
          width: 180,
          align: 'center'
        },
        {
          title: '在职状态',
          key: 'jobStatus',
          width: 100,
          align: 'center'
        },
        {
          title: '毕业院校',
          key: 'schoolName',
          width: 100,
          align: 'center'
        },
        {
          title: '联系方式',
          key: 'contactInfo',
          width: 160,
          align: 'center'
        },
        {
          title: '更新时间',
          key: 'updateTime',
          width: 180,
          align: 'center'
        },
        {
          title: '审核状态',
          slot: 'reviewStatus',
          width: 100,
          align: 'center'
        },

        {
          title: '操作',
          key: 'action',
          width: 120,
          slot: 'action',
          align: 'center'
        }
      ],
      statusList: ['待审核', '审核成功', '审核失败'],
      collegeInfoList: []
    }
  },
  created() {
    const token = localStorage.getItem('token')
    this.headers = { 'X-Access-Token': token }
    this.baseURL = window.location.origin.includes('10.49.2.38') ? process.env.VUE_APP_BASE_API_IP : process.env.VUE_APP_BASE_API
    this.uploadAction = `${this.baseURL}/isp-talent/college/talentCollegeInfo/importExcel`
  },
  mounted() {
    this.initData()
  },
  methods: {
    goAdd() {
      this.$refs.studentModal.showFun('', 'add')
    },
    goEdit(row) {
      this.$refs.studentModal.showFun(row.id, 'edit', row.name)
    },
    goDetail(row) {
      this.$refs.studentModal.showFun(row.id, 'detail', row.name)
    },
    goDel(id) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '您确定要删除本条记录吗？',
        onOk: () => {
          ApplyApi.delCollegeInfo({ id }).then((res) => {
            if (res.success) {
              this.$Message.success('删除成功')
              this.initData()
            }
          })
        }
      })
    },
    change(key, e) {
      this.$set(this.params, key, e)
    },
    changePage(val) {
      this.page.pageNo = val
      this.initData()
    },
    pageChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.initData()
    },
    handleSearch() {
      this.page.pageNo = 1
      this.initData()
    },
    handleReset() {
      this.page.pageNo = 1
      this.params = {}
      this.initData()
    },
    downLoadTemplate() {
      window.open('https://s3.tztalent.cn/tz-talent/template/2021年新引进大学生情况统计表（模板）.xls', '_blank')
    },
    exceededSize(file) {
      this.$Notice.warning({
        title: '文件大小限制',
        desc: `文件${file.name}太大了，不能超过50M.`
      })
    },
    handleSuccess(response) {
      this.showMessage = true
      this.uploadMessage = response.message
    },
    initData() {
      ApplyApi.getCollegeInfoList({ ...this.params, pageNo: this.page.pageNo, pageSize: this.page.pageSize }).then((res) => {
        if (res.success) {
          this.collegeInfoList = res.result.records
          this.page.pageNo = res.result.current
          this.page.total = res.result.total
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.student_box {
  .title {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: #333333;
    line-height: 52px;
    padding-left: 16px;
    border-bottom: 1px #e8e9ed solid;
  }
  .filter_form {
    padding: 20px;
  }
  .btns_class {
    display: flex;
    justify-content: space-between;
    padding: 0 20px 20px;
    .left_btns {
      display: flex;
      align-items: center;
      .ivu-btn {
        margin-right: 20px;
      }
    }
  }
  .student_table {
    margin: 0 20px;
    .name {
      color: #3f93f7;
      cursor: pointer;
    }
    .action_btn {
      color: #3f93f7;
      cursor: pointer;
    }
  }
  .page {
    padding: 12px 20px;
  }
}
.tips_content {
  max-height: 600px;
  overflow-y: auto;
}
</style>
<style lang="less">
.student_box {
  .filter_form {
    .ivu-select-input {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  ::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }
}
</style>
